module.exports = __webpack_public_path__ + "img/51.b1e0ff20.jpg";